import { FC } from 'react'
import { useTranslation } from 'react-i18next';
// Types
import QuestionTypes from 'types/QuestionTypes';
import QuizTypes from 'types/QuizTypes';
// Models
import IQuestion from 'models/Question';
// Redux
import { useAppSelector } from 'hooks/useStore';
// Selectors
import { selectQuestion, selectQuiz } from 'store/quiz/quizSelectors';
import { selectQuestionReady } from 'store/player/playerSelectors';

const Question:FC = () => {
  const { t } = useTranslation('common');
  // State
  const quiz = useAppSelector(selectQuiz);
  const question:IQuestion = useAppSelector(selectQuestion);
  const questionReady:boolean = useAppSelector(selectQuestionReady);

  const isPollQuiz = quiz.type === QuizTypes.Poll;

  if ( !questionReady && !question.video ) return null;
  return (
    <div className="py-2 px-4">
      <p className={`${isPollQuiz ? 'text-xl text-white' : 'text-sm'} font-bold text-center`}>
        {question.title}
        {question.type === QuestionTypes.MultiChoice ? (
          <span className="block text-gray-500 text-xs">{`( ${t('quiz.questionPage.canBeMoreThan1Answer')} )`}</span>
        ) : null}
      </p>
    </div>
  )
}

export default Question;
